import { gql } from '@apollo/client'
import { PUBLIC_PROFILE_CARD_FIELDS } from '../fragments/publicProfileCardFields'

// Queries of the "Red" tab and the career organization page.

export const SEARCH_PUBLIC_PROFILES = gql`
  ${PUBLIC_PROFILE_CARD_FIELDS}
  query SearchPublicProfiles($term: String, $limit: Int, $offset: Int) {
    searchPublicProfiles(term: $term, limit: $limit, offset: $offset) {
      profiles {
        ...PublicProfileCardFields
      }
      totalCount
      offset
      limit
    }
  }
`

export const GET_CAREER_ORGANIZATION_DIRECTORY = gql`
  query GetCareerOrganizationDirectory($term: String, $limit: Int, $offset: Int) {
    careerOrganizationDirectory(term: $term, limit: $limit, offset: $offset) {
      organizations {
        id
        name
        image
      }
      totalCount
      offset
      limit
    }
  }
`

export const GET_CAREER_ORGANIZATION_PROFILES = gql`
  ${PUBLIC_PROFILE_CARD_FIELDS}
  query GetCareerOrganizationProfiles(
    $careerOrganizationId: ID!
    $period: CareerOrganizationProfilesPeriodEnum!
    $limit: Int
    $offset: Int
  ) {
    careerOrganizationProfiles(
      careerOrganizationId: $careerOrganizationId
      period: $period
      limit: $limit
      offset: $offset
    ) {
      careerOrganization {
        id
        name
        image
      }
      profiles {
        ...PublicProfileCardFields
      }
      totalCount
      offset
      limit
    }
  }
`
